/**
 * Prefer URL `search`; then debounced input; if both empty, use all-digit `order_id` from the URL
 * so the first list fetch matches `?orderId=972` before the effect appends `search=972`.
 */
export function effective_list_search(
  url_search: string,
  debounced_search: string,
  order_id_from_url?: string | null
): string | undefined {
  const from_url = (url_search ?? '').trim();
  if (from_url) return from_url;
  const from_state = (debounced_search ?? '').trim();
  if (from_state) return from_state;
  const order_hint = (order_id_from_url ?? '').trim();
  if (/^\d+$/.test(order_hint)) return order_hint;
  return undefined;
}
